import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { routeUrls } from '../constants/constants';
import { UserService } from '../services/user.service';
import { isMobileApp } from './mobile.utils';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router, private authService: AuthService,private userservice:UserService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const targetUrl = state.url;
    const { pathname } = window.location;

    // Allow mobile app WebView access — verify both the query param and that
    // the request originates from a native WebView (not a regular browser).
    // API calls still enforce auth via the injected bearer token.
    if (isMobileApp(route.queryParams)) {
      return of(true);
    }

    return this.auth.isAuthenticated$.pipe(
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          if(pathname === '/home' || pathname === '/contact-us' || pathname === '/key-features'){
            return
          }
          if(pathname === '/' || pathname === ''){
            this.router.navigateByUrl('home');
          }else{
            this.authService.loginWithRedirect({
              appState: { target: routeUrls.AUTH_CALLBACK, returnTo: targetUrl},
            });
            sessionStorage.setItem('targetUrl', targetUrl);
          }
        }
        else {
          sessionStorage.setItem('targetUrl', targetUrl);
          if (pathname === '/pre-dashboard') {
            return;
          }
          this.router.navigateByUrl(routeUrls.PREDASHBOARD);
        }
      })
    );
  }
}
